exports.install = function (Vue, options) {
	//获取设备列表
	Vue.prototype.getdevices = function(value)
	{
		return this.axiosget("/api/devices/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('devices',response.data.data.list);
			}
			return response;
		})
	};
	//获取单条设备
	Vue.prototype.getdevice = function(value)
	{
		return this.axiosget("/api/devices/read",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('device',response.data.data);
			}
			return response;
		})
	};
	//添加设备
	Vue.prototype.adddevices = function(value)
	{
		this.axiospost("/api/devices/add",value);
	};
	//删除设备
	Vue.prototype.deldevices = function(value)
	{
		this.axiospost("/api/devices/delete",value);
	};
}